import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Instagram, Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-deep-dark/50 backdrop-blur-xl pt-16 pb-8 px-4" data-id="element-8">
      <div className="max-w-7xl mx-auto" data-id="element-9">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-10">
          {/* Brand */}
          <div className="space-y-4" data-id="element-11">
            <h3 className="text-2xl font-bold text-white" data-id="element-12">
              VISION<span className="text-neon-cyan" data-id="element-13">PLUS</span>
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-14">
              Fikirleri Hayalden Gerçeğe Dönüştürüyoruz.
            </p>
          </div>

          {/* Contact */}
          <div className="space-y-4" data-id="element-15">
            <h4 className="text-white font-semibold" data-id="element-16">İletişim</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-17">
              <li className="flex items-center gap-3" data-id="element-18">
                <Mail className="w-4 h-4 text-neon-cyan" data-id="element-19" />
                <a href="mailto:myigityilmazer@outlook.com" className="hover:text-white transition-colors" data-id="element-20">
                  myigityilmazer@outlook.com
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-21">
                <Phone className="w-4 h-4 text-neon-cyan" data-id="element-22" />
                <a href="tel:+905051351615" className="hover:text-white transition-colors" data-id="element-23">
                  +90 505 135 16 15
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-24">
                <MapPin className="w-4 h-4 text-neon-cyan mt-1" data-id="element-25" />
                <span data-id="element-26">
                  Alanya Alaaddin Keykubat Üniversitesi,
                  <br data-id="element-27" />
                  TEKMER Binası, No:86/3, Kestel, Alanya
                </span>
              </li>
            </ul>
          </div>

          {/* Links */}
          <div className="space-y-4" data-id="element-28">
            <h4 className="text-white font-semibold" data-id="element-29">Şirket</h4>
            <ul className="space-y-2 text-sm text-gray-400" data-id="element-30">
              <li data-id="element-31">
                <Link to="/hakkimizda" className="hover:text-white transition-colors" data-id="element-32">
                  Vizyonumuz
                </Link>
              </li>
              <li data-id="element-33">
                <Link to="/#ventures" className="hover:text-white transition-colors" data-id="element-34">
                  Girişimlerimiz
                </Link>
              </li>
              <li data-id="element-35">
                <Link to="/iletisim" className="hover:text-white transition-colors" data-id="element-36">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div className="space-y-4" data-id="element-37">
            <h4 className="text-white font-semibold" data-id="element-38">Bizi Takip Edin</h4>
            <div className="flex gap-4" data-id="element-39">
              <a href="#" className="p-2 bg-white/5 rounded-full hover:bg-white/10 hover:text-neon-cyan transition-all text-gray-400" data-id="element-40">
                <Linkedin className="w-5 h-5" data-id="element-41" />
              </a>
              <a href="#" className="p-2 bg-white/5 rounded-full hover:bg-white/10 hover:text-neon-cyan transition-all text-gray-400" data-id="element-42">
                <Twitter className="w-5 h-5" data-id="element-43" />
              </a>
              <a href="#" className="p-2 bg-white/5 rounded-full hover:bg-white/10 hover:text-electric-violet transition-all text-gray-400" data-id="element-44">
                <Instagram className="w-5 h-5" data-id="element-45" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 text-center text-sm text-gray-500" data-id="element-46">
          <p data-id="element-47">
            &copy; {new Date().getFullYear()} VisionPlus. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>;
}